
// let's get this party started
document.addEventListener('DOMContentLoaded', function () {


	// ACTIVE TOGGLE
	let toggleHold = false;
	document.querySelectorAll('.js_toggle_trigger').forEach(trigger => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			if (!toggleHold) {
				toggleHold = true;
				let toggleTarget = ''
				if (trigger.getAttribute('data-target')) {
					toggleTarget = document.querySelector(trigger.getAttribute('data-target'))
				} else if (trigger.getAttribute('href')) {
					toggleTarget = document.querySelector(trigger.getAttribute('href'))
				} else {
					toggleTarget = trigger.closest('.js_toggle');
				}
				trigger.classList.toggle('m-active');
				toggleTarget.classList.toggle('m-active');

				setTimeout(() => {
					toggleHold = false;
				}, 500);
			}
		});
	});
	// ========================


	const swiper = new Swiper('.js_swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		resistanceRatio: 0,
		allowTouchMove: false,
		autoHeight: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
	});


	document.querySelectorAll('.js_swiper_trigger').forEach(trigger => {
		trigger.addEventListener('click', (e) => {
			document.querySelectorAll('.js_swiper_trigger').forEach(item => {
				item.classList.remove('m-active');
			});
			const targetSlide = trigger.getAttribute('data-target') - 1;
			swiper.slideTo(targetSlide);
			trigger.classList.add('m-active');
		});
	});




	// // TEXT ROWS SLIDEDOWN


	// const
	// 	defaultLineheight = 1.8,
	// 	defaultLines = 12;
	// // SLIDEDOWNS
	// const txtSlideDown = function () {
	// 	const
	// 		slideDownParent = this.closest('.js_txtslidedown'),
	// 		slideDown = slideDownParent.querySelector('.js_txtslidedown_content'),

	// 		slideDownHeight = slideDownParent.querySelector('.js_txtslidedown_text').scrollHeight;

	// 	if (slideDownParent.classList.contains('isopened')) {

	// 		let slideDownMinRows = Number(slideDownParent.getAttribute('data-minrows'));
	// 		if (!slideDownMinRows) {
	// 			slideDownMinRows = defaultLines;
	// 		}
	// 		// console.log(slideDownMinRows);

	// 		let lineheight = Number(slideDownParent.getAttribute('data-lineheight'));
	// 		if (!lineheight) {
	// 			lineheight = defaultLineheight;
	// 		}


	// 		slideDownParent.classList.remove('isopened');

	// 		// stuff for window resize
	// 		slideDown.style.height = slideDownHeight + 'px';
	// 		setTimeout(function () {
	// 			slideDown.style.height = (slideDownMinRows * lineheight) + 'em';
	// 		}, 30);
	// 	}
	// 	else {
	// 		slideDownParent.classList.add('isopened');
	// 		slideDown.style.height = slideDownHeight + 'px';

	// 		// stuff for window resize
	// 		setTimeout(function () {
	// 			slideDown.style.height = 'auto';
	// 		}, 300);
	// 	}
	// };

	// document.querySelectorAll('.js_txtslidedown_trigger').forEach(trigger => {
	// 	trigger.addEventListener('click', txtSlideDown, false);
	// });

	// // if (window.matchMedia("(min-width: 768px)").matches) {

	// document.querySelectorAll('.js_txtslidedown').forEach(item => {
	// 	const contentWrapper = item.querySelector('.js_txtslidedown_content'),
	// 		realHeight = item.querySelector('.js_txtslidedown_text').scrollHeight;

	// 	let slideDownMinRows = Number(item.getAttribute('data-minrows'));
	// 	if (!slideDownMinRows) {
	// 		slideDownMinRows = defaultLines;
	// 	}
	// 	let lineheight = Number(item.getAttribute('data-lineheight'));
	// 	if (!lineheight) {
	// 		lineheight = defaultLineheight;
	// 	}

	// 	if (realHeight > slideDownMinRows * lineheight) {

	// 		item.classList.add('isactive')
	// 		contentWrapper.style.minHeight = `${slideDownMinRows * lineheight}em`;
	// 	}
	// });

	// // }
	// // ========================









	// // SLIDEDOWN
	// let slideHold = false;
	// const slideUp = (target, duration = 500) => {
	// 	slideHold = true;
	// 	target.classList.remove('m-active');
	// 	target.style.transitionProperty = 'height, margin, padding';
	// 	target.style.transitionDuration = duration + 'ms';
	// 	target.style.boxSizing = 'border-box';
	// 	target.style.height = target.offsetHeight + 'px';
	// 	target.offsetHeight;
	// 	target.style.overflow = 'hidden';
	// 	target.style.height = 0;
	// 	target.style.paddingTop = 0;
	// 	target.style.paddingBottom = 0;
	// 	target.style.marginTop = 0;
	// 	target.style.marginBottom = 0;
	// 	window.setTimeout(() => {
	// 		target.style.display = 'none';
	// 		target.style.removeProperty('height');
	// 		target.style.removeProperty('padding-top');
	// 		target.style.removeProperty('padding-bottom');
	// 		target.style.removeProperty('margin-top');
	// 		target.style.removeProperty('margin-bottom');
	// 		target.style.removeProperty('overflow');
	// 		target.style.removeProperty('transition-duration');
	// 		target.style.removeProperty('transition-property');
	// 		slideHold = false;
	// 	}, duration);
	// }
	// const slideDown = (target, duration = 500) => {
	// 	target.classList.add('m-active');
	// 	slideHold = true;
	// 	target.style.removeProperty('display');
	// 	let display = window.getComputedStyle(target).display;
	// 	if (display === 'none') display = 'block';
	// 	target.style.display = display;
	// 	let height = target.offsetHeight;
	// 	target.style.overflow = 'hidden';
	// 	target.style.height = 0;
	// 	target.style.paddingTop = 0;
	// 	target.style.paddingBottom = 0;
	// 	target.style.marginTop = 0;
	// 	target.style.marginBottom = 0;
	// 	target.offsetHeight;
	// 	target.style.boxSizing = 'border-box';
	// 	target.style.transitionProperty = "height, margin, padding";
	// 	target.style.transitionDuration = duration + 'ms';
	// 	target.style.height = height + 'px';
	// 	target.style.removeProperty('padding-top');
	// 	target.style.removeProperty('padding-bottom');
	// 	target.style.removeProperty('margin-top');
	// 	target.style.removeProperty('margin-bottom');
	// 	window.setTimeout(() => {
	// 		target.style.removeProperty('height');
	// 		target.style.removeProperty('overflow');
	// 		target.style.removeProperty('transition-duration');
	// 		target.style.removeProperty('transition-property');
	// 		slideHold = false;
	// 	}, duration);
	// }
	// const slideToggle = (target, duration = 500) => {
	// 	return window.getComputedStyle(target).display === 'none'
	// 		? slideDown(target, duration)
	// 		: slideUp(target, duration);
	// }

	// document.querySelectorAll('.js_slidedown_trigger').forEach(trigger => {
	// 	trigger.addEventListener('click', (e) => {
	// 		e.preventDefault();
	// 		if (!slideHold) {
	// 			let slideDuration = trigger.getAttribute('data-duration')
	// 				? trigger.getAttribute('data-duration')
	// 				: 500;
	// 			let thisTarget = trigger.getAttribute('data-target')
	// 				? document.querySelector(trigger.getAttribute('data-target'))
	// 				: trigger.closest('.js_slidedown').querySelector('.js_slidedown_content');
	// 			slideToggle(thisTarget, slideDuration);
	// 			if (trigger.classList.contains('m-active')) {
	// 				trigger.classList.remove('m-active');
	// 				if (trigger.closest('.js_slidedown')) {
	// 					trigger.closest('.js_slidedown').classList.remove('m-active');
	// 				}
	// 			} else {
	// 				trigger.classList.add('m-active');
	// 				if (trigger.closest('.js_slidedown')) {
	// 					trigger.closest('.js_slidedown').classList.add('m-active');
	// 				}
	// 			}
	// 		}
	// 	});
	// });
	// // ========================



});